module.exports = __webpack_public_path__ + "static/profile-pic-fd9769acc2ee3e494f260862f10e933f.jpg";